var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46 13.6c-.37 0-.677-.123-.923-.37a1.252 1.252 0 0 1-.37-.922V3.692c0-.368.123-.675.37-.922.246-.247.554-.37.922-.37h11.815c.369 0 .676.123.923.37.246.247.37.554.37.922v8.616c0 .368-.124.675-.37.922-.247.247-.554.37-.923.37H2.46Zm5.907-5.508-6.4-4.184v8.4a.48.48 0 0 0 .138.354.48.48 0 0 0 .354.138h11.815a.48.48 0 0 0 .354-.138.48.48 0 0 0 .139-.354v-8.4l-6.4 4.184Zm0-.892 6.153-4H2.213l6.154 4Zm-6.4-3.292V3.2v9.108a.48.48 0 0 0 .138.354.48.48 0 0 0 .354.138h-.492V3.908Z",
    fill: "#000"
  })));
};
export default SvgEnvelope;